var toGeoJSON = require("@mapbox/togeojson");

$(document).ready(function () {
  if ($("#lines-company-map").length > 0) {
    $.ajax(window.defaultMapData.mapFileLink).done(function (xml) {
      const geoJson = toGeoJSON.kml(xml);
      createMap(geoJson);
    });
  }
});

function getColorFromName(name) {
  const map = window.defaultMapData.colorMatchJSON;
  return map[name] || "#000000";
}

function createMap(geoJson) {
  mapboxgl.accessToken =
    "pk.eyJ1IjoiZW5hbnoiLCJhIjoiY21iaGMzbHZkMDhwOTJvcHRubjZ6a2NhayJ9.dz9vkoegvyn4qNwDdWynPw";
  const map = new mapboxgl.Map({
    container: "lines-company-map", // the id of the div element
    style: "mapbox://styles/enanz/cmbg0qglt006r01sqbzbfcf18", // style URL
    center: window.defaultMapData.center,
    zoom: window.defaultMapData.zoom,
    // cooperativeGestures: true,
  });

  //create hidden marker used for address
  const addressMarker = new mapboxgl.Marker({
    color: "#ffD4AC",
    draggable: false,
  });

  const geocoder = new MapboxGeocoder({
    accessToken: mapboxgl.accessToken,
    countries: "NZ",
    proximity: [174.778454, -41.26304],
    placeholder: "Search an address",
    render: function (item) {
      var placeName = item.place_name.split(",");
      return (
        '<div class="mapboxgl-ctrl-geocoder--suggestion"><div class="mapboxgl-ctrl-geocoder--suggestion-title needsclick">' +
        placeName[0] +
        '</div><div class="mapboxgl-ctrl-geocoder--suggestion-address needsclick">' +
        placeName.splice(1, placeName.length).join(",") +
        "</div></div>"
      );
    },
  });

  geocoder.addTo("#lines-company-geocoder");
  geocoder.on("result", (e) => {
    document.activeElement.blur();
    $("input").blur();
    map.flyTo({
      center: e.result.center,
      zoom: 10,
    });

    addressMarker.setLngLat(e.result.center).addTo(map);
  });

  geocoder.on("clear", () => {
    document.activeElement.blur();
    $("input").blur();
    addressMarker.remove();
  });

  map.on("load", () => {
    // let mapData = JSON.parse(response);

    let LayerName = "lines-company-layer";

    const primaryFill = "#003f2e";
    const primaryOutline = "#FFFFFF";

    map.addSource(LayerName, {
      type: "geojson",
      data: geoJson,
    });

    //add a hover effect fill color and show name

    map.addLayer({
      id: LayerName + "-polygon",
      type: "fill",
      source: LayerName,
      paint: {
        "fill-color": primaryFill,
        "fill-opacity": 0.6,
      },
    });

    map.addLayer({
      id: LayerName + "-outline",
      type: "line",
      source: LayerName,
      paint: {
        "line-color": primaryOutline,
        "line-width": 1, // Set your desired width here
      },
    });

    // Load an image to use as the pattern from an external URL.
    // map.loadImage(
    //   "https://docs.mapbox.com/mapbox-gl-js/assets/colorado_flag.png",
    //   (err, image) => {
    //     // Throw an error if something goes wrong.
    //     if (err) throw err;

    //     // Add the image to the map style.
    //     map.addImage("pattern", image);

    //     // Create a new layer and style it using `fill-pattern`.
    //     map.addLayer({
    //       id: "pattern-layer",
    //       type: "fill",
    //       source: LayerName,
    //       paint: {
    //         "fill-pattern": [
    //           "match",
    //           ["get", "name"],
    //           "Powerco",
    //           "pattern",
    //           "none",
    //         ],
    //       },
    //     });
    //   }
    // );

    const hoverPopup = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: false,
    });

    map.on("mousemove", LayerName + "-polygon", (e) => {
      // Change the cursor style as a UI indicator.
      map.getCanvas().style.cursor = "pointer";
      const name = e.features[0].properties.Name;
      if (!name) {
        return;
      }
      hoverPopup
        .setLngLat(e.lngLat)
        .setHTML(`<p class="c-lc-map__popup-text"><b> ${name} </b></p>`)
        .addTo(map);
    });

    map.on("mouseleave", LayerName + "-polygon", () => {
      map.getCanvas().style.cursor = "";
      hoverPopup.remove();
    });

    map.on("click", LayerName + "-polygon", (e) => {
      e.originalEvent.cancelBubble = true;
      const selectedColor = getColorFromName(e.features[0].properties.Name);

      const fillColorExpr = [
        "case",
        ["==", ["get", "name"], e.features[0].properties.Name],
        selectedColor,
        primaryFill,
      ];

      map.setPaintProperty(LayerName + "-polygon", "fill-color", fillColorExpr);

      var popupInner = "";
      if (e.features[0].properties.Name) {
        popupInner += `<p class="c-lc-map__popup-text"><b> ${e.features[0].properties.Name} </b></p>`;
      }
      if (e.features[0].properties.Phone) {
        popupInner += `<p class="c-lc-map__popup-text"><b>Phone</b><br/> <a href="tel:${e.features[0].properties.Phone}" >${e.features[0].properties.Phone}</a> </p>`;
      }
      if (e.features[0].properties.Website) {
        popupInner += `<p class="c-lc-map__popup-text"><b>Website</b><br/> <a target="_blank" href="${e.features[0].properties.Website}">${e.features[0].properties.Website}</a> </p>`;
      }

      if (popupInner == "") {
        popupInner = `<p class="c-lc-map__popup-text"><b>No information available</b></p>`;
      }

      var popupHTML = `
          <div class="c-lc-map__popup">
            ${popupInner}
          </div>
        `;

      const clickPopup = new mapboxgl.Popup()
        .setLngLat(e.lngLat)
        .setHTML(popupHTML)
        .addTo(map);

      // on close set the popup global variable to false
      clickPopup.on("close", () => {
        //on close reset the fill opacity of the polygon layer
        map.setPaintProperty(LayerName + "-polygon", "fill-color", primaryFill);
      });
    });
  });
}
